import { h, Component } from 'preact';

class CartIcon extends Component {
  render () {
    const { color, size } = this.props;

    return (
      <svg
        fill={color || '#000000'}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        width={size}
        height={size}
      >
        <path
          d="M 7.6582031 2 C 6.8615365 2 6.1344998 2.4791595 5.8203125 3.2109375 L 3.3398438 9 L 2.0019531 9 C 1.6889531 9 1.3950781 9.1455313 1.2050781 9.3945312 C 1.0170781 9.6425312 0.95315625 9.964625 1.0351562 10.265625 L 3.5957031 19.53125 C 3.8347031 20.39525 4.6274375 21 5.5234375 21 L 18.476562 21 C 19.372563 21 20.164344 20.396203 20.402344 19.533203 L 22.962891 10.267578 C 23.045891 9.9665781 22.982922 9.6425312 22.794922 9.3945312 C 22.604922 9.1455313 22.310047 9 21.998047 9 L 20.660156 9 L 18.177734 3.2128906 L 18.179688 3.2128906 C 17.865994 2.4777169 17.13651 2 16.339844 2 L 7.6582031 2 z M 7.6582031 4 L 16.339844 4 L 18.482422 9 L 5.5175781 9 L 7.6582031 4 z M 8 12 C 8.552 12 9 12.448 9 13 L 9 17 C 9 17.552 8.552 18 8 18 C 7.448 18 7 17.552 7 17 L 7 13 C 7 12.448 7.448 12 8 12 z M 12 12 C 12.552 12 13 12.448 13 13 L 13 17 C 13 17.552 12.552 18 12 18 C 11.448 18 11 17.552 11 17 L 11 13 C 11 12.448 11.448 12 12 12 z M 16 12 C 16.552 12 17 12.448 17 13 L 17 17 C 17 17.552 16.552 18 16 18 C 15.448 18 15 17.552 15 17 L 15 13 C 15 12.448 15.448 12 16 12 z"
          fill={color || '#000000'}
        />
      </svg>
    );
  }
}

export default CartIcon;
